"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BasicEmpty = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var antd_1 = require("antd");
function BasicEmpty() {
    return (0, jsx_runtime_1.jsx)(antd_1.Empty, {});
}
exports.BasicEmpty = BasicEmpty;
